import React from 'react';
import './App.less';
import AppRouter from './components/base/AppRouter';
import Store from './components/hoc/Store';
import './styles/index.css';

const App: React.FC = () => {
    return (
        <Store>
            <AppRouter />
        </Store>
    );
};

export default App;
